import axios from "axios";
import ResponseAlerts from "../functions/ResponseAlerts";

const BASE_ACCESS_GROUP = "access-control-service/groups";

const RESOURCES = {
	LIST_GROUPS_PAGINATED: (
		page,
		searchText,
		organizationId,
		orderBy,
		limit,
		unitId = null,
		filters = {},
	) => {
		const params = {
			page,
			limit: limit ?? 8,
			searchBy: searchText,
			orderBy: orderBy?.collumnTitle || orderBy || "",
			orderDirection: orderBy?.orderDirection || "",
		}

		if (unitId) {
			params.id_condominium = unitId;
		}
		["startDate", "startTime", "endDate", "endTime", "direction"].forEach((key) => {
			if (filters[key]) params[key] = filters[key];
		});

		return `${BASE_ACCESS_GROUP}/organizations/${organizationId}/paginated?${new URLSearchParams(params)}`;
	},

	LIST_ORGANIZATION_ACCESS_GROUP: (organizationId) => `${BASE_ACCESS_GROUP}/organizations/${organizationId}`,
	CREATE_ACCESS_GROUP: () => BASE_ACCESS_GROUP,
	CREATE_BULK_ACCESS_GROUPS: () => `${BASE_ACCESS_GROUP}/bulk-by-ids`,
	DELETE_ACCESS_GROUP: (accessGroupId) => `${BASE_ACCESS_GROUP}/${accessGroupId}`,
	UPDATE_ACCESS_GROUP: (accessGroupId) => `${BASE_ACCESS_GROUP}/${accessGroupId}`,
	LIST_CONDOMINIUM_ACCESS_GROUP: (condominiumId) => `${BASE_ACCESS_GROUP}/condominiums/${condominiumId}`,
	GET_ONE_UUID: (uuid) => `${BASE_ACCESS_GROUP}/uuid/${uuid}`,
};

class AccessGroupService {
	static async listAccessGroupsPaginated(
		page,
		searchText,
		organizationId,
		orderBy,
		cancelToken,
		limit,
		unitId = null,
		filters = {},
	) {
		try {
			const response = await axios.get(
				RESOURCES.LIST_GROUPS_PAGINATED(
					page,
					searchText,
					organizationId,
					orderBy,
					limit,
					unitId,
					filters,
				),
				{
					signal: cancelToken,
				}
			);
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar grupos",
			});
			return error.response;
		}
	}

	static async listOrganizationAccessGroups(organizationId) {
		try {
			const response = await axios.get(
				RESOURCES.LIST_ORGANIZATION_ACCESS_GROUP(organizationId),
			);
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar grupos da organização",
			});
			return error.response;
		}
	}

	static async listCondominiumAccessGroups(condominiumId) {
		try {
			const response = await axios.get(
				RESOURCES.LIST_CONDOMINIUM_ACCESS_GROUP(condominiumId),
			);
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar grupos do condomínio",
			});
			return error.response;
		}
	}

	static async getOneUuid(uuid) {
		try {
			return await axios.get(RESOURCES.GET_ONE_UUID(uuid));
		} catch (error) {
			console.error(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao obter grupo de acesso",
			});
			return error.response;
		}
	}

	static async createAccessGroup(payload) {
		try {
			const response = await axios.post(
				RESOURCES.CREATE_ACCESS_GROUP(),
				payload,
			);
			ResponseAlerts({
				response: response,
				successMessage: "Grupo cadastrado com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao cadastrar grupo",
			});
			return error.response;
		}
	}

	static async createBulkAccessGroups(payload) {
		try {
			const response = await axios.post(
				RESOURCES.CREATE_BULK_ACCESS_GROUPS(),
				payload,
			);
			ResponseAlerts({
				response: response,
				successMessage: "Grupo cadastrado com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao cadastrar grupo",
			});
			return error.response;
		}
	}

	static async updateAccessGroup(accessGroupId, payload) {
		try {
			const response = await axios.put(
				RESOURCES.UPDATE_ACCESS_GROUP(accessGroupId),
				payload,
			);
			ResponseAlerts({
				response: response,
				successMessage: "Grupo editado com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao editar grupo",
			});
			return error.response;
		}
	}
	static async deleteAccessGroup(accessGroupId) {
		try {
			const response = await axios.delete(
				RESOURCES.DELETE_ACCESS_GROUP(accessGroupId),
			);
			ResponseAlerts({
				response: response,
				successMessage: "Grupo excluído com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao excluir grupo",
			});
			return error.response;
		}
	}
}
export default AccessGroupService;
